var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copied-hashtags",class:{ 'is-visible': _vm.isVisible}},[_c('h3',[_vm._v("hashtags copiadas com sucesso!")])])}
var staticRenderFns = []

export { render, staticRenderFns }